import { Injectable } from '@angular/core';
import { Seller } from '../../classes/seller';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class SellerService extends UserService{

  constructor(
    protected requestService: RequestService, 
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'sellers';
  };

  protected getOneUserUrl(): string {

    return 'seller';
  };

  protected parseObject(obj: any): Seller {

    return obj as Seller;
  };

  protected parseArray(objs: any): Seller[] {

    return objs as Seller[];
  };

}



// WEBPACK FOOTER //
// ./src/app/services/sellers/seller.service.ts